import { render, staticRenderFns } from "./Route.vue?vue&type=template&id=9cebd9a8&scoped=true&"
var script = {}
import style0 from "./Route.vue?vue&type=style&index=0&id=9cebd9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cebd9a8",
  null
  
)

export default component.exports